import React from 'react';
import './SHDGradient.css';
import { SHDGradientOverlayProps } from './SHDGradient.d';

const SHDGradient: React.FC<
  React.PropsWithChildren<SHDGradientOverlayProps>
> = ({
  variant = 'gray',
  direction = '180deg',
  className = '',
  style = {},
  children,
}) => {
  return (
    <div
      className={`gradient-background ${variant} ${className}`}
      style={{
        ...style,
        ['--direction' as string]: direction,
      }}
    >
      {children}
    </div>
  );
};

export default SHDGradient;
